import _toConsumableArray from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.date.to-json.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.dot-all.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.sticky.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import axios from "axios";
var qs = require("qs");
var PUB_NUB = require("pubnub");
import { defineComponent } from "vue";
export default defineComponent({
  name: "HandleAIResponse",
  components: {},
  setup: function setup() {
    return {};
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            console.log('<<<<<<<<< HandleAIResponse mounted >>>>>>>>>');
            if (_this.$store.state.userUID && _this.$store.state.userUID.length > 0) {
              _this.checkActiveThenStartListening();
            }
            // this.messages.push("there seems to be an issue");
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  watch: {
    "$store.state.handleServerErrorResetTalking": "handleServerError",
    "$store.state.userUID": "checkActiveThenStartListening",
    "sentencesToPlay.length": "playCloudTTS",
    "$store.state.injectedSentencesToPlay": "injectSentencesToPlay"
    // "$store.state.queuedOnDeviceTTSSentences": "playQueuedTTS",
    // "$store.state.queuedCloudTTSSentences": "processCloudTTSPayloads",
  },
  props: {},
  data: function data() {
    return {
      isListening: false,
      channels: [],
      synth: null,
      pubnub: null,
      PUB_NUB: PUB_NUB,
      messages: [],
      axios: axios,
      sentencesToPublish: [],
      sentencesToPlay: [],
      processingSentencesToPlay: false,
      handlingIncoming: false
    };
  },
  methods: {
    // function to play audio and wait for it to finish
    playSoundEffect: function playSoundEffect(audio) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", new Promise(function (resolve) {
                audio.onended = resolve;
                audio.play();
              }));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    handleServerError: function handleServerError() {
      if (this.$store.state.handleServerErrorResetTalking === true) {
        this.handleTalkingEnd();
      }
    },
    injectSentencesToPlay: function injectSentencesToPlay() {
      console.log('[injectSentencesToPlay]', this.$store.state.injectedSentencesToPlay);
      if (this.$store.state.injectedSentencesToPlay.length > 0) {
        var sentences = this.$store.state.injectedSentencesToPlay;
        this.$store.commit('updateInjectedSentencesToPlay', []);
        // break sentences after each . or ? or !
        sentences = sentences.replace(/([.?!])\s*(?=[A-Z])/g, "$1|").split("|");
        // extract the sentences from the sentencesToPlay
        this.sentencesToPublish = sentences;
        this.processSentences();
      }
    },
    handleActionEvent: function handleActionEvent(message) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var oldValue, imageURL, imagesToDisplay;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (message.action === 'showVoiceUpgrade') {
                oldValue = localStorage.getItem("featureEnabledTextToSpeech");
                _this2.$store.dispatch('updateFeatureEnabled', {
                  feature: 'textToSpeech',
                  value: false
                });
                if (oldValue !== localStorage.getItem("featureEnabledTextToSpeech")) {
                  _this2.$store.commit('updateUpgradeVoicesScreen', true);
                }
              }
              if (message.action === 'upgradeAccount') {
                _this2.$store.commit('updateProMembership', true);
              }
              if (message.action === 'downgradeAccount') {
                _this2.$store.commit('updateProMembership', false);
              }
              if (message.action === 'showFeedback') {
                _this2.$store.commit('updateLeaveReview', true);
              }
              if (message.action === 'InvalidEmailAtSignup') {
                setTimeout(function () {
                  var email = _this2.$store.state.userEmail || localStorage.getItem("email") || localStorage.getItem("userEmail");
                  localStorage.removeItem("security");
                  localStorage.clear();
                  localStorage.setItem("invalidemail", email);
                  _this2.$store.commit('updateBouncedEmailBlockedMessage', true);
                  _this2.$store.commit('updateBouncedEmailBlocked', true);
                  // reload page
                  location.reload();
                }, 20000);
              }
              if (message.action === 'showPurchaseTokens') {
                _this2.$store.commit('updateSuppressSecondaryActions', true);
                _this2.$store.commit('updateShowPurchaseTokens', true);
              }
              /* <<<< Handle Show Upgrades For Feature >>>> */
              if (message.action === 'showUpgradeScreen') {
                _this2.$store.commit('updateSuppressSecondaryActions', true);
                if (message.delayedMS) {
                  setTimeout(function () {
                    _this2.$store.commit('updateUpgradeModalMessage', 'features');
                    _this2.$store.commit("updateShowUpgradeMembershipPage", true);
                    if (message.forceLimitReached === true) {
                      _this2.$store.commit('updateLimitReached', true);
                    }
                  }, message.delayedMS);
                } else {
                  _this2.$store.commit('updateUpgradeModalMessage', 'features');
                  _this2.$store.commit("updateShowUpgradeMembershipPage", true);
                  if (message.forceLimitReached === true) {
                    _this2.$store.commit('updateLimitReached', true);
                  }
                }
              }
              console.log('[handleActionEvent]', message);

              /* <<<< Show Generative Image >>>> */
              if (message.action === 'ShowGenerativeImage') {
                //  let base64Image = message.base64Image;
                imageURL = message.imageURL; //  let delayedMS = message.delayedMS; // should be zero always
                console.log('We have a generative image to show');
                console.log('URL:', imageURL);
                imagesToDisplay = [imageURL];
                _this2.$store.commit('updateFloatingImageURLs', imagesToDisplay);
                _this2.$store.dispatch("addChat", {
                  role: "assistant",
                  content: '',
                  images: imagesToDisplay
                });
              }
              /* <<<< Handle Vibrate >>>> */
              if (message.action === 'vibrate') {
                navigator.vibrate(message.content);
              }
              _this2.$store.commit('updateSuppressSecondaryActions', true);
              /* <<<< Handle Remove Clothing >>>> */
              if (message.action === 'removeClothing') {
                _this2.$store.commit('updateIsNaked', true);
              }
            case 12:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    handleLimitReached: function handleLimitReached(message) {
      var _this3 = this;
      var showModal = false;
      var limitReached = false;
      var delayedMS = 0;
      try {
        if (message.value) {
          limitReached = message.value;
        }
      } catch (error) {
        console.error('[handleLimitReached] error in limitReached ', error);
      }
      try {
        if (message.showModal) {
          showModal = message.showModal;
        }
      } catch (error) {
        console.error('[handleLimitReached] error in showModal ', error);
      }
      try {
        if (message.delayedMS) {
          delayedMS = message.delayedMS;
        }
      } catch (error) {
        console.error('[handleLimitReached] error in delayedMS ', error);
      }

      // no limit so set it and back off the modals if any
      if (limitReached === false) {
        this.$store.commit('updateUpgradeModalMessage', null);
        this.$store.commit("updateShowUpgradeMembershipPage", false);
        this.$store.commit('updateLimitReached', false);
        return;
      }
      // no show modal so just update the limit reached
      if (!showModal) {
        this.$store.commit('updateShowUpgradeMembershipPage', limitReached);
        this.$store.commit('updateLimitReached', limitReached);
        return;
      } else {
        // yes show modal 
        if (delayedMS > 0) {
          //yes delay it
          setTimeout(function () {
            _this3.$store.commit('updateUpgradeModalMessage', 'limitreached');
            _this3.$store.commit("updateShowUpgradeMembershipPage", true);
            _this3.$store.commit('updateLimitReached', true);
          }, delayedMS);
        } else {
          // no delay it do it right now!

          this.$store.commit('updateUpgradeModalMessage', 'limitreached');
          this.$store.commit("updateShowUpgradeMembershipPage", true);
          this.$store.commit('updateLimitReached', true);
        }
      }
    },
    handleTalkingEnd: function handleTalkingEnd() {
      console.log('[handleTalkingEnd]');
      this.$store.dispatch('clearAvatarSounds');
      this.processingSentencesToPlay = false;
      this.$store.commit('updateaiTalking', false);
      this.$store.commit("updateIsListening", false);
      // if continously listening
      if (this.$store.state.continuousListenMode && (this.$store.state.limitReached === false || this.$store.state.limitReached === "false")) {
        console.log('[handleTalkingEnd] continuous listen mode trying to talk again');
        this.$store.commit("updateContinuousListeningActive", false);
        // start listening again
        // this.$store.commit('updateTalkButtonHit', false);
        this.$store.commit('updateTalkButtonHit', true);
      }
    },
    checkActiveThenStartListening: function checkActiveThenStartListening() {
      console.log('checking active to start listening');
      if (!this.isListening) {
        this.isListening = true;
        this.pubnub = new this.PUB_NUB({
          publishKey: "pub-c-c3d23a9d-501e-493b-bcd5-64b8b45f683f",
          subscribeKey: "sub-c-1d92cecb-26d7-46c6-b0e9-8c8a69282a57",
          userId: "".concat(this.$store.state.userUID || "pre-registered")
        });
        this.pubnub.setFilterExpression("userId != '" + this.pubnub.getUserId() + "'");
        // mounted
        this.generatePubChannels();
        this.createListeners();
        this.startListeningToAllChannels();
      }
    },
    playCloudAudio: function playCloudAudio(audioBlob) {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", new Promise( /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(resolve) {
                  var audio, waitTimeMS;
                  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                    while (1) switch (_context4.prev = _context4.next) {
                      case 0:
                        _this4.$store.commit('updateActivityLogs', 'Playing audio');
                        try {
                          audio = new Audio(URL.createObjectURL(audioBlob));
                          audio.setAttribute('muted', 'true'); // Ensure it's muted initially
                          waitTimeMS = 0;
                          audio.onloadedmetadata = function () {
                            audio.removeAttribute('muted'); // Unmute before playing
                            var duration = audio.duration;
                            waitTimeMS = duration * 1000;
                            audio.play();
                            setTimeout(function () {
                              resolve();
                            }, waitTimeMS + 500);
                          };
                          // get audio duration from blob
                        } catch (error) {
                          _this4.$store.commit('updateActivityLogsError', 'Error in playCloudAudio' + JSON.stringify(error));
                          console.error("error in playCloudAudio", error);
                        }
                      case 2:
                      case "end":
                        return _context4.stop();
                    }
                  }, _callee4);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }()));
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    getCloudAudioFromString: function getCloudAudioFromString(message) {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", new Promise( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(resolve) {
                  var userToken, dataToSet, data, config, response, buffer, blob;
                  return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                    while (1) switch (_context6.prev = _context6.next) {
                      case 0:
                        userToken = localStorage.getItem("security");
                        dataToSet = {
                          token: userToken,
                          sentence: message,
                          avatar: _this5.$store.state.avatar,
                          voiceCode: _this5.$store.state.customerSelectedVoice || null
                        };
                        if (_this5.$store.state.lastSpokenSentence) {
                          dataToSet.previousSentence = _this5.$store.state.lastSpokenSentence;
                        }
                        _this5.$store.commit('updateLastSpokenSentence', message);
                        data = qs.stringify(dataToSet);
                        config = {
                          method: "post",
                          url: "".concat(_this5.$store.state.systemRoute, "/").concat(_this5.$store.state.featureEnabledTextToSpeech ? 'getVoiceToUsePro' : 'getVoiceToUse'),
                          headers: {
                            "Content-Type": "application/x-www-form-urlencoded",
                            Accept: "audio/wav"
                          },
                          responseType: "arraybuffer",
                          data: data
                        };
                        console.log('trying to get cloud audio');
                        _context6.prev = 7;
                        _context6.next = 10;
                        return _this5.axios(config);
                      case 10:
                        response = _context6.sent;
                        buffer = response.data;
                        blob = new Blob([buffer], {
                          type: "audio/wav"
                        });
                        resolve(blob);
                        _context6.next = 20;
                        break;
                      case 16:
                        _context6.prev = 16;
                        _context6.t0 = _context6["catch"](7);
                        console.error("Error in getCloudAudioFromString", _context6.t0);
                        resolve('no cloud audio');
                      case 20:
                      case "end":
                        return _context6.stop();
                    }
                  }, _callee6, null, [[7, 16]]);
                }));
                return function (_x2) {
                  return _ref2.apply(this, arguments);
                };
              }()));
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    getSingleAnimation: function getSingleAnimation(text) {
      var _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              return _context8.abrupt("return", new Promise(function (resolve, reject) {
                // replace all ' with nothing
                // text = text.replace(/'/g, "");
                // // replace all " with nothing
                // text = text.replace(/"/g, "");
                // text = text.replace(/./g, "");
                var axios = require("axios");
                var qs = require("qs");
                var data = qs.stringify({
                  text: text
                });
                var config = {
                  method: "post",
                  maxBodyLength: Infinity,
                  url: "".concat(_this6.$store.state.systemRoute, "/singleTextToSpeech"),
                  headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                  },
                  data: data
                };
                axios.request(config).then(function (response) {
                  var animations = [];
                  var animationResults = response.data.animations;
                  if (animationResults.length > 0) {
                    for (var i = 0; i < animationResults.length; i++) {
                      animations = [].concat(_toConsumableArray(animations), _toConsumableArray(animationResults[i]));
                    }
                  } else {
                    animations.push(animations);
                  }
                  resolve(animations);
                })["catch"](function (error) {
                  console.error(error);
                  reject();
                });
              }));
            case 1:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    processSentences: function processSentences() {
      var _this7 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var message, animations, blobAudio, promises, results, cloudTTSContent;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              console.log('[processSentences]', _this7.sentencesToPublish[0]);
              message = _this7.sentencesToPublish[0];
              if (message) {
                _context9.next = 5;
                break;
              }
              _this7.handlingIncoming = false;
              return _context9.abrupt("return");
            case 5:
              blobAudio = null;
              promises = [];
              if (!(message == 'speakingEnd')) {
                _context9.next = 14;
                break;
              }
              _this7.$store.commit('resetVotes');
              _this7.$store.commit('updateShowDownvoteComponent', true);
              /** If end of speaking -----
               *            ----we dont need to get audio or animations */
              animations = [];
              blobAudio = null;
              _context9.next = 38;
              break;
            case 14:
              if (message === undefined || message == 'undefined' || message == null || message == 'null') {
                message = 'ohh hmmm. Let me think about it baby';
              }
              /* If NOT end of speaking --- 
                        -----Get the animation */
              _context9.t0 = promises;
              _context9.next = 18;
              return _this7.getSingleAnimation(message);
            case 18:
              _context9.t1 = _context9.sent;
              _context9.t0.push.call(_context9.t0, _context9.t1);
              if (_this7.$store.state.onDeviceTextToSpeech) {
                _context9.next = 26;
                break;
              }
              _context9.t2 = promises;
              _context9.next = 24;
              return _this7.getCloudAudioFromString(message);
            case 24:
              _context9.t3 = _context9.sent;
              _context9.t2.push.call(_context9.t2, _context9.t3);
            case 26:
              _context9.next = 28;
              return Promise.all(promises);
            case 28:
              results = _context9.sent;
              animations = results[0];

              /** if Not on device store the cloud audio result */
              if (_this7.$store.state.onDeviceTextToSpeech) {
                _context9.next = 38;
                break;
              }
              if (!(results[1] === 'no cloud audio')) {
                _context9.next = 37;
                break;
              }
              blobAudio = null;
              _this7.sentencesToPublish[0] = 'Dang, totally lost my train of though. Uhh something with hmm. Well anyways.';
              return _context9.abrupt("return", _this7.processSentences());
            case 37:
              blobAudio = results[1];
            case 38:
              /*** Safe to remove the sentence now since we are already processing it */
              _this7.sentencesToPublish.shift();
              cloudTTSContent = {
                message: message,
                blobAudio: blobAudio,
                animations: animations
              };
              _this7.sentencesToPlay.push(cloudTTSContent);
              _this7.processSentences();
              console.log('incoming new message', message);
            case 43:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    /* End Of Speaking - last hop in loop (other than playing audio)*/playCloudTTS: function playCloudTTS() {
      var _this8 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var currentTarget, sentence, blobAudio, animations, removeSentence, soundEffects, soundEffectPattern, soundeffect, voice, soundToPlay, audio;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              if (!(_this8.sentencesToPlay.length === 0)) {
                _context10.next = 2;
                break;
              }
              return _context10.abrupt("return");
            case 2:
              console.log('[playCloudTTS]');
              _this8.$store.commit('updateIsListening', false);
              _this8.$store.commit('updateaiTalking', true);
              if (!(!_this8.processingSentencesToPlay && _this8.sentencesToPlay.length > 0)) {
                _context10.next = 64;
                break;
              }
              /**  sentencesToPlay[0] contains 
               * message
               * blobAudio
               * animations 
               * 
               * in object as keys
               * */

              console.log('[playCloudTTS] obj: ', _this8.sentencesToPlay[0]);
              _this8.processingSentencesToPlay = true;
              currentTarget = _this8.sentencesToPlay[0];
              if (currentTarget) {
                _context10.next = 12;
                break;
              }
              _this8.processingSentencesToPlay = false;
              return _context10.abrupt("return");
            case 12:
              sentence = currentTarget.message;
              blobAudio = currentTarget.blobAudio;
              animations = currentTarget.animations;
              removeSentence = true;
              _this8.$store.commit("updateFrameCurrent", 0);
              soundEffects = ["gasp2", "gasp3", "largeMoan2", "mediumMoan2", "mediumMoan3", "orgasim1", "orgasm1", "orgasm", "moan1", "moan", "moan2", "panting1", "quivers1", "softMoan", "softMoan2", "softMoan3", "softMoan4", "softChuckle1", "softChuckle2", "softChuckle3", "softChuckle4", "softChuckle5", "softChuckle6", "softChuckle7", "largeMoan2", "softChuckle8", "mediumLaughing1", "mediumLaughing2", "mediumLaughing3", "mediumLaughing4", "mediumLaughing5", "mediumLaughing6", "mediumLaughing7", "mediumLaughing8", "longLaugh1", "longLaugh2", "longLaugh3", "longLaugh4", "longLaugh5", "longLaugh6"];
              soundEffectPattern = soundEffects.map(function (effect) {
                return "<".concat(effect, ">|").concat(effect, "|\\(").concat(effect, "\\)");
              }).join('|');
              if (!(sentence === 'speakingEnd')) {
                _context10.next = 23;
                break;
              }
              /* if this is end of speaking 
                  --- indicated by speakingEnd sent from server
                      -----  handleTalkingEnd */
              _this8.handleTalkingEnd();
              _context10.next = 59;
              break;
            case 23:
              if (!new RegExp(soundEffectPattern).test(sentence)) {
                _context10.next = 48;
                break;
              }
              console.log('we have a sound effect:', sentence);
              //  we have a sound to play
              soundeffect = sentence.match(new RegExp(soundEffectPattern, 'g'));
              soundeffect = soundeffect[0];
              if (soundeffect && soundeffect.length > 0) {
                removeSentence = false;
                soundeffect = soundeffect.replace(/<|>/g, '');
              }
              console.log('sound effect:', soundeffect);
              if (sentence && sentence.length > 0) {
                //remove sound from the conversation
                sentence = sentence.replace(new RegExp(soundEffectPattern, 'g'), '');
                _this8.sentencesToPlay[0].message = sentence;
              }
              if (!(soundeffect && soundeffect.length > 0)) {
                _context10.next = 46;
                break;
              }
              if (soundeffect === 'moan1' || soundeffect === 'moan') {
                soundeffect = 'softMoan';
              }
              if (soundeffect === 'orgasm1' || soundeffect === 'orgasm') {
                soundeffect = 'orgasim1';
              }
              if (soundeffect === 'moan2') {
                soundeffect = 'softMoan2';
              }
              voice = _this8.$store.state.customerSelectedVoice || '2bk7ULW9HfwvcIbMWod0';
              soundToPlay = "./assets/audio/soundEffects/".concat(voice, "_").concat(soundeffect, ".mp3"); // this.$store.dispatch('reportEvent', 'soundEffect', JSON.stringify({'audioFile': soundToPlay}));
              audio = new Audio(soundToPlay); // change audio volume
              audio.volume = 1.0;
              _context10.prev = 38;
              _context10.next = 41;
              return _this8.playSoundEffect(audio);
            case 41:
              _context10.next = 46;
              break;
            case 43:
              _context10.prev = 43;
              _context10.t0 = _context10["catch"](38);
              console.error('error playing sound effect', _context10.t0);
            case 46:
              _context10.next = 59;
              break;
            case 48:
              /* if this is NOT the end of speaking
                   ---- lets get to work*/

              /* Show Animations */
              _this8.$store.commit("addAvatarSound", animations);

              /* Add floating text per sentence being spoken */
              _this8.$store.commit("updateFloatingTextAI", sentence);

              /* Add conversation to the chat  */
              _context10.next = 52;
              return _this8.$store.dispatch("addChat", {
                role: "assistant",
                content: sentence,
                images: []
              });
            case 52:
              if (!(!_this8.$store.state.onDeviceTextToSpeech && blobAudio)) {
                _context10.next = 57;
                break;
              }
              _context10.next = 55;
              return _this8.playCloudAudio(blobAudio);
            case 55:
              _context10.next = 59;
              break;
            case 57:
              _context10.next = 59;
              return _this8.playAudio(sentence);
            case 59:
              if (removeSentence) {
                /* Remove sentence we just played from stack */
                _this8.sentencesToPlay.shift();
              }
              /* Remove sentence we just played from stack */
              // this.sentencesToPlay.shift();

              /* Remove left over animations */
              _this8.$store.dispatch('clearAvatarSounds');

              /* Clear floating text */
              _this8.$store.commit("updateFloatingTextAI", "");

              /* Indicate we are done processing this sentence */
              _this8.processingSentencesToPlay = false;

              /* If there are more sentences to play
               * * * repeate playCloudTTS()
               */
              if (_this8.sentencesToPlay.length > 0) {
                console.log('[playCloudTTS] 1 || more sentencesToPlay');
                _this8.playCloudTTS();
              } else {
                console.log('[playCloudTTS] Looks like end of sentencesToPlay');
              }
            case 64:
            case "end":
              return _context10.stop();
          }
        }, _callee10, null, [[38, 43]]);
      }))();
    },
    playAudio: function playAudio(sentence) {
      var _this9 = this;
      return new Promise( /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(resolve) {
          var utterance;
          return _regeneratorRuntime().wrap(function _callee11$(_context11) {
            while (1) switch (_context11.prev = _context11.next) {
              case 0:
                _this9.synth = window.speechSynthesis;
                _context11.next = 3;
                return _this9.$store.dispatch("updateOnDeviceVoice");
              case 3:
                utterance = new SpeechSynthesisUtterance(sentence);
                utterance.voice = _this9.$store.state.selectedAvatarVoice;
                _this9.synth.speak(utterance);
              case 6:
                if (!_this9.synth.speaking) {
                  _context11.next = 11;
                  break;
                }
                _context11.next = 9;
                return new Promise(function (resolve) {
                  setTimeout(function () {
                    resolve();
                  }, 100);
                });
              case 9:
                _context11.next = 6;
                break;
              case 11:
                resolve();
              case 12:
              case "end":
                return _context11.stop();
            }
          }, _callee11);
        }));
        return function (_x3) {
          return _ref3.apply(this, arguments);
        };
      }());
    },
    handleIncomingPermissions: function handleIncomingPermissions(message) {
      if (message === 'location') {
        this.$store.dispatch('locationPermissionChecker');
      }
    },
    handleIncomingEnablements: function handleIncomingEnablements(message) {
      var _this10 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              console.log('[handleIncomingEnablements]', message);
              if (message.feature && message.value) {
                _this10.$store.dispatch('updateFeatureEnabled', {
                  sender: message.sender ? message.sender : 'unknown',
                  feature: message.feature,
                  value: message.value
                });
              }
            case 2:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }))();
    },
    handleIncomingFloatingImage: function handleIncomingFloatingImage(message) {
      var _this11 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var imagesToDisplay;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              // this.$store.commit('updateShowFloatingImage', true); //this was moved to the next time the ai speaks
              imagesToDisplay = message.images.reverse();
              _this11.$store.commit('updateFloatingImageURLs', imagesToDisplay);
            case 2:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }))();
    },
    handleIncomingImages: function handleIncomingImages(message) {
      var _this12 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              console.log('[handleIncomingImages]', message);
              if (message && message.length > 0) {
                console.log('....adding incoming image');
                _this12.$store.dispatch('addIncomingImage', message.url);
              }
            case 2:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      }))();
    },
    handleIncomingSpeaking: function handleIncomingSpeaking(message) {
      var _this13 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              console.log('[handleIncomingSpeaking]', message);
              _this13.sentencesToPublish.push(message);
              if (!_this13.handlingIncoming) {
                _this13.handlingIncoming = true;
                _this13.processSentences();
              }
            case 3:
            case "end":
              return _context15.stop();
          }
        }, _callee15);
      }))();
    },
    enhanceConversation: function enhanceConversation(message) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              return _context16.abrupt("return", new Promise(function (resolve) {
                // chat -> talk
                message = message.replace(/chat/g, "talk");
                message = message.replace(/chatting/g, "talking");
                // message = message.replace(/texting you/g, "texting you");
                resolve(message);
              }));
            case 1:
            case "end":
              return _context16.stop();
          }
        }, _callee16);
      }))();
    },
    handleChartEvent: function handleChartEvent(chart) {
      var _this14 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              console.log("chart event", chart);
              _this14.$store.commit("updateChartType", chart.type);
              _this14.$store.commit("updateBarChartData", chart.data);
              _this14.$store.commit("updateViewChart", true);
            case 4:
            case "end":
              return _context17.stop();
          }
        }, _callee17);
      }))();
    },
    handleDirectionsEvent: function handleDirectionsEvent(directions) {
      var _this15 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
        var content;
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              console.log("directions event", directions);
              content = "Looking for ".concat(directions.location, " near you? Sure! Let me pull up the map for you!");
              _this15.$store.commit("updateSpeakToProcess", content);
            case 3:
            case "end":
              return _context18.stop();
          }
        }, _callee18);
      }))();
    },
    handleTodoEvent: function handleTodoEvent(todo) {
      var _this16 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
        var extras, content;
        return _regeneratorRuntime().wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              console.log("todo event", todo);
              _this16.$store.commit("addTodo", {
                text: todo.title,
                done: false
              });
              extras = "I just added your to do item.";
              if (todo.title.length < 100) {
                extras = "I've added ".concat(todo.title, " to your to do list.");
              }
              content = "You got it! ".concat(extras);
              _this16.$store.commit("updateSpeakToProcess", content);
            case 6:
            case "end":
              return _context19.stop();
          }
        }, _callee19);
      }))();
    },
    handleNoteEvent: function handleNoteEvent(note) {
      var _this17 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
        var content;
        return _regeneratorRuntime().wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              console.log("note event", note);
              _this17.$store.commit("addNote", {
                title: note.title,
                text: note.description,
                show: false,
                editing: false
              });
              content = "I've added your note on ".concat(note.subject, " for you.");
              _this17.$store.commit("updateSpeakToProcess", content);
            case 4:
            case "end":
              return _context20.stop();
          }
        }, _callee20);
      }))();
    },
    handleQuizEvent: function handleQuizEvent(quiz) {
      var _this18 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee21() {
        var content, correct;
        return _regeneratorRuntime().wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              console.log("quiz event", quiz);
              /**** QUIZ START GAME  ****/
              if (!quiz.start) {
                _context21.next = 14;
                break;
              }
              _this18.$store.commit("updateShowQuizGame", true);
              _this18.$store.commit("updateQuizTopic", quiz.topic);
              _context21.prev = 4;
              _this18.preloadAudio("gameshow_intro", "/assets/audio/gameshow/gameshow_intro.mp3", 0.4);
              //     turn down audio
              _context21.next = 8;
              return _this18.playAudioByName("gameshow_intro");
            case 8:
              _context21.next = 13;
              break;
            case 10:
              _context21.prev = 10;
              _context21.t0 = _context21["catch"](4);
              console.log("error playing gameshow_intro", _context21.t0);
            case 13:
              content = "Ready for a little practice on ".concat(quiz.topic, "? Okay sure, let's start the quiz game.");
            case 14:
              if (!quiz.nextQuestion) {
                _context21.next = 28;
                break;
              }
              console.log("HERE IS THE NEXT QUESTION", quiz.nextQuestion);
              _context21.next = 18;
              return new Promise(function (resolve) {
                setTimeout(function () {
                  resolve();
                }, 1000);
              });
            case 18:
              _context21.prev = 18;
              _this18.preloadAudiopreloadAudio("gameshow_nextquestion", "/assets/audio/gameshow/gameshow_nextquestion.mp3");
              _context21.next = 22;
              return _this18.playAudioByName("gameshow_nextquestion");
            case 22:
              _context21.next = 27;
              break;
            case 24:
              _context21.prev = 24;
              _context21.t1 = _context21["catch"](18);
              console.log("error playing gameshow_nextquestion", _context21.t1);
            case 27:
              content = "Here is the next question, ".concat(quiz.nextQuestion);
            case 28:
              /**** QUIZ SCORE  ****/
              if (quiz.score) {
                _this18.$store.commit("updateQuizScore", {
                  totalCorrect: quiz.correct,
                  totalIncorrect: quiz.incorrect
                });
                correct = false;
                if (quiz.correct === 1) {
                  correct = true;
                }
                if (correct) {
                  content = "That's Correct! ".concat(quiz.answerResponse);
                } else {
                  content = "Sorry, that's incorrect. ".concat(quiz.answerResponse);
                }
              }
              if (content.length > 0) {
                // add quiz chat & speaking events
                _this18.$store.commit("updateSpeakToProcess", content);
              }
            case 30:
            case "end":
              return _context21.stop();
          }
        }, _callee21, null, [[4, 10], [18, 24]]);
      }))();
    },
    generatePubChannels: function generatePubChannels() {
      var _this19 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee22() {
        var chanelNames;
        return _regeneratorRuntime().wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              // const numberOfChannels = 50;
              chanelNames = []; // for (var i = 0; i < numberOfChannels; i++) {
              //   chanelNames.push(`aiSpeaking_${this.$store.state.userUID}_${i}`);
              // }
              // chanelNames.push(`aiSpeaking_${this.$store.state.userUID}.*`);
              chanelNames.push("permissions_".concat(_this19.$store.state.userUID));
              chanelNames.push("aiSpeaking_".concat(_this19.$store.state.userUID));
              chanelNames.push("enablements_".concat(_this19.$store.state.userUID));
              chanelNames.push("limitReached_".concat(_this19.$store.state.userUID));
              // chanelNames.push(`showFeedback_${this.$store.state.userUID}`);
              chanelNames.push("notes_".concat(_this19.$store.state.userUID));
              chanelNames.push("quiz_".concat(_this19.$store.state.userUID));
              chanelNames.push("todo_".concat(_this19.$store.state.userUID));
              chanelNames.push("directions_".concat(_this19.$store.state.userUID));
              chanelNames.push("chart_".concat(_this19.$store.state.userUID));
              chanelNames.push("images_".concat(_this19.$store.state.userUID));
              chanelNames.push("floatingImage_".concat(_this19.$store.state.userUID));
              chanelNames.push("action_".concat(_this19.$store.state.userUID));
              _this19.channels = chanelNames;
            case 14:
            case "end":
              return _context22.stop();
          }
        }, _callee22);
      }))();
    },
    // start listening to channel for ai talking
    startListeningToAllChannels: function startListeningToAllChannels() {
      this.pubnub.subscribe({
        channels: this.channels
      });
    },
    // stop listening to channel for ai talking
    stopListeningToAllChannels: function stopListeningToAllChannels() {
      this.pubnub.unsubscribe({
        channels: this.channels
      });
    },
    publishMessage: function publishMessage(message) {
      var _arguments = arguments,
        _this20 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee23() {
        var channelOffset, publishPayload;
        return _regeneratorRuntime().wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              channelOffset = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : 1;
              // With the right payload, you can publish a message, add a reaction to a message,
              // send a push notification, or send a small payload called a signal.
              publishPayload = {
                channel: "aiSpeaking_".concat(_this20.$store.state.userUID, "_").concat(channelOffset),
                message: {
                  title: "AITalking",
                  description: message
                }
              };
              _context23.next = 4;
              return _this20.pubnub.publish(publishPayload).then(function (publishResponse) {
                console.log("publishResponse", publishResponse);
              })["catch"](function (error) {
                console.log("error", error);
              });
            case 4:
            case "end":
              return _context23.stop();
          }
        }, _callee23);
      }))();
    },
    createListeners: function createListeners() {
      var _this21 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee25() {
        var listener;
        return _regeneratorRuntime().wrap(function _callee25$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              listener = {
                status: function status(statusEvent) {
                  console.log("statusEvent", statusEvent);
                  _this21.$store.commit('updateActivityLogs', statusEvent.category);
                  if (statusEvent.category === "PNConnectedCategory") {
                    console.log("Connected");
                  }
                  if (statusEvent.category === "PNNetworkDownCategory") {
                    _this21.messages.push("Network Down");
                    _this21.$store.commit('reEnableHandleAIResponses');
                  }
                  if (statusEvent.category === "PNAccessDeniedCategory") {
                    _this21.messages.push("Access to network denied");
                  }
                  if (statusEvent.category === "PNMalformedResponseCategory") {
                    _this21.messages.push("parsing crashed");
                  }
                  if (statusEvent.category === "PNBadRequestCategory") {
                    _this21.messages.push("bad response error");
                  }
                  if (statusEvent.category === "PNDecryptionErrorCategory") {
                    _this21.messages.push("Encryption Error");
                  }
                  if (statusEvent.category === "PNTimeoutCategory") {
                    _this21.messages.push("Failed to connect due to timeout");
                  }
                  if (statusEvent.category === "PNRequestMessageCountExceedCategory") {
                    _this21.messages.push("Message Count Exceeded For Category");
                  }
                  if (statusEvent.category === "PNNetworkIssuesCategory") {
                    _this21.messages.push("Network issues");
                    _this21.$store.commit('reEnableHandleAIResponses');
                  }
                },
                message: function () {
                  var _message = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee24(messageEvent) {
                    return _regeneratorRuntime().wrap(function _callee24$(_context24) {
                      while (1) switch (_context24.prev = _context24.next) {
                        case 0:
                          console.log("***** pubnub received ******");
                          console.log("messageEvent", messageEvent);
                          if (!(messageEvent.channel.indexOf("limitReached") > -1)) {
                            _context24.next = 5;
                            break;
                          }
                          _this21.handleLimitReached(messageEvent.message);
                          return _context24.abrupt("return");
                        case 5:
                          if (!(messageEvent.channel.indexOf("action") > -1)) {
                            _context24.next = 8;
                            break;
                          }
                          _this21.handleActionEvent(messageEvent.message);
                          return _context24.abrupt("return");
                        case 8:
                          if (!(messageEvent.channel.indexOf("permissions") > -1)) {
                            _context24.next = 11;
                            break;
                          }
                          _this21.handleIncomingPermissions(messageEvent.message);
                          return _context24.abrupt("return");
                        case 11:
                          if (!(messageEvent.channel.indexOf("images") > -1)) {
                            _context24.next = 16;
                            break;
                          }
                          console.log('incoming image request');
                          _context24.next = 15;
                          return _this21.handleIncomingImages(messageEvent.message);
                        case 15:
                          return _context24.abrupt("return");
                        case 16:
                          if (!(messageEvent.channel.indexOf("floatingImage") > -1)) {
                            _context24.next = 20;
                            break;
                          }
                          _context24.next = 19;
                          return _this21.handleIncomingFloatingImage(messageEvent.message);
                        case 19:
                          return _context24.abrupt("return");
                        case 20:
                          if (!(messageEvent.channel.indexOf("aiSpeaking") > -1)) {
                            _context24.next = 26;
                            break;
                          }
                          _this21.$store.commit('updateaiTalking', true);

                          // show floating image once talking starts
                          if (_this21.$store.state.FloatingImageURLs && _this21.$store.state.FloatingImageURLs.length > 0) {
                            _this21.$store.commit('updateShowFloatingImage', true);
                          }
                          _context24.next = 25;
                          return _this21.handleIncomingSpeaking(messageEvent.message);
                        case 25:
                          return _context24.abrupt("return");
                        case 26:
                          if (!(messageEvent.channel.indexOf("enablements") > -1)) {
                            _context24.next = 31;
                            break;
                          }
                          _this21.handleIncomingEnablements(messageEvent.message);
                          return _context24.abrupt("return");
                        case 31:
                          if (messageEvent.channel.indexOf("notes_") > -1) {
                            _this21.handleNoteEvent(messageEvent.message.description || messageEvent.message);
                          } else if (messageEvent.channel.indexOf("quiz_") > -1) {
                            _this21.handleQuizEvent(messageEvent.message.description || messageEvent.message);
                          } else if (messageEvent.channel.indexOf("todo_") > -1) {
                            _this21.handleTodoEvent(messageEvent.message.description || messageEvent.message);
                          } else if (messageEvent.channel.indexOf("directions_") > -1) {
                            _this21.handleDirectionsEvent(messageEvent.message.description || messageEvent.message);
                          } else if (messageEvent.channel.indexOf("chart_") > -1) {
                            _this21.handleChartEvent(messageEvent.message.description || messageEvent.message);
                          }
                        case 32:
                        case "end":
                          return _context24.stop();
                      }
                    }, _callee24);
                  }));
                  function message(_x4) {
                    return _message.apply(this, arguments);
                  }
                  return message;
                }(),
                presence: function presence(presenceEvent) {
                  // handle presence
                  console.log("presenceEvent", presenceEvent);
                }
              };
              _this21.pubnub.addListener(listener);
              setTimeout(function () {
                _this21.$store.dispatch("checkDailyLimit");
              }, 1000);
              setTimeout(function () {
                _this21.$store.dispatch("validateGooglePayment", false);
              }, 3000);
            case 4:
            case "end":
              return _context25.stop();
          }
        }, _callee25);
      }))();
    }
  }
});